import React, { useEffect, useRef, useState } from "react";

import { store } from "react-notifications-component";

import api from "../../../services/api";
import { isTotvs } from "../../../services/globalFunctions";

import InputV3 from "../../input/novo/input_v3";

import * as S from "./styles";
import { theme } from "../../../styles/theme";
import { Auxiliar, H5, H6, Minimo } from "../../../styles/stylesTypography";

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
export const USER = "@userinfo";

const AcordionCardSimulation = ({
  hasErrorSelect,
  hasErrorUsers,
  hasErrorRevenues,
  onPlanSelected,     
  onUsersCountChanged,  
  onCouponChanged,       
  onRevenuesChanged,    
  onValueMonth,
  onValuePerMonthChanged,
  onValueRevenuesPrePagoChanged,
  onValueRevenuesPrePagoWithNotDiscount,
  onFullValueForUsersChanged,
  
  onMessageCupomChanged,
  onCupomRecorrenciaChanged,
  onFullValueMonthNotDiscountChanged,
  onFullValueMonthWithDiscountChanged,
  onFullValueAnual,
  onValueAnual,
  onFullValueNotDiscountAnual,
  onIdPlanGridCard,
  onIdPlanCard,
  acordionError,
  onQtdDocuments,
  onQtdPrescriptions,
  onDiscountMonths,
  isUserCountDisabled = false,
  // Checkout de parceiros: plano fixo e parceiro (vindo da URL) travado no lugar do select de plano
  fixedPlanId = null,
  partnerMode = false,
  selectedPartner = null,
  hasErrorPartner = false,
  }) => {
    
  const isPartnerCheckout = partnerMode;
    
  const isCheckoutPath =
    typeof window !== "undefined" &&
    typeof window.location?.pathname === "string" &&
    window.location.pathname.startsWith("/checkout");

  const getCheckoutPlanId = () => {
    if (typeof window === "undefined" || !isCheckoutPath) return null;
    const search = window.location.search || "";
    if (!search) return null;
    const query = search.substring(1);
    const directId = Number(query.split("&")[0]);
    if (!isNaN(directId) && directId > 0) return directId;
    const params = new URLSearchParams(search);
    const idParam = Number(params.get("id"));
    if (!isNaN(idParam) && idParam > 0) return idParam;
    return null;
  };

  const checkoutPlanId = fixedPlanId || getCheckoutPlanId();
  const checkoutPlanFallbackLabel =
    checkoutPlanId === 9
      ? "PLANO PROTHEUS"
      : checkoutPlanId === 10
      ? "PLANO API"
      : checkoutPlanId === 11
      ? "PLANO OMIE"
      : "";
  const checkoutPlanDefault =
    checkoutPlanId && checkoutPlanFallbackLabel
      ? { value: checkoutPlanId, label: checkoutPlanFallbackLabel }
      : null;

  const [pathnamePlanId , setPathnamePlanId] = useState(0)
  const [planSeleted, setPlanSeleted] = useState(checkoutPlanDefault || {})
  const [percentageApplied, setPercentageApplied] = useState(0)

  const [plans, setPlans] = useState(checkoutPlanDefault || { value: "", label: "" });
  const [infoPlans, setInfoPlans] = useState([]);
  const [IdPlans, setIdPlans] = useState(0);
  const [precoIds, setPrecoIds] = useState([]);
  const [cupom, setCupom] = useState("");
  const [cupomValue, setCupomValue] = useState(null);
  const [cupomInfo, setCupomInfo] = useState("");
  const [cupomRecorrencia, setCupomRecorrencia] = useState(null);
  const [discountMonths, setDiscountMonths] = useState(0);
  const [users, setUsers] = useState(0);
  const [hasSelectedPlan, setHasSelectedPlan] = useState(false);
  const [selectedPlanType, setSelectedPlanType] = useState("anual");
  const [plan, setPlan] = useState([]);
  const [revenues, setRevenues] = useState(0);

  const [qtdDocuments, setQtdDocuments] = useState("");
  const [qtdPrescriptions, setQtdPrescriptions] = useState("");

  const [hasErrorCupom, setHasErrorCupom] = useState(false);

  const [isClearUsers, setIsClearUsers] = useState(false);
  const [isClearRevenues, setIsClearRevenues] = useState(false);
  const [acordionPlanError, setAcordionPlanError] = useState(false);
  const [hasError, setHasError] = useState({
    selectedPlan: false,
    userCount: false,
    revenues: false,
  });

  const [utmParam, setUtmParam] = useState({
    utm_campaign: "",
    utm_id: 0,
    utm_medium: "",
    utm_source: "",
    cupom: "",
    button: "",
  })

  const [hasCupom, setHasCupom] = useState(false)

  const [activeCampaign, setActiveCampaign] = useState(undefined);
  // Indica se o valor atual de `cupom` foi preenchido automaticamente pela
  // campanha ativa (e não digitado pelo usuário), para saber se pode ser
  // reajustado/limpo ao trocar o plano selecionado.
  const [cupomFromCampaign, setCupomFromCampaign] = useState(false);

  // Converte valor em formato BRL ("1.234,56") para número (1234.56).
  const brlToNumber = (value) => {
    if (typeof value === "number") return value;
    if (value === null || value === undefined) return 0;

    const normalized = String(value)
      .trim()
      .replace(/[^\d.,-]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");

    const number = Number(normalized);

    return isNaN(number) ? 0 : number;
  };

  // Regra de aplicação do cupom por recorrência - espelha o backend (compra.service):
  // MENSAL só vale em plano mensal, ANUAL só em plano anual e sem recorrência vale para todos.
  const cupomAplicaAnual =
    Boolean(cupomValue) && (cupomRecorrencia === null || cupomRecorrencia === "ANUAL");
  const cupomAplicaMensal =
    Boolean(cupomValue) && (cupomRecorrencia === null || cupomRecorrencia === "MENSAL");
  const cupomAplicaPrePago = Boolean(cupomValue) && cupomRecorrencia === null;

  useEffect(() => {
    const getActiveCampaign = async () => {
      try {
        const response = await api.get("/campaigns");
        const data = Array.isArray(response.data?.data)
          ? response.data.data
          : Array.isArray(response.data)
          ? response.data
          : [];
        setActiveCampaign(data.length > 0 ? data[0] : null);
      } catch (err) {
        setActiveCampaign(null);
      }
    };

    getActiveCampaign();
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const getPlanInfo = async () => {
    try {
      const response = await api.get('/planos/funcoes');

      setInfoPlans(response.data.data.planos);
    } catch (err) {
      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(err, "ERRO-555 Erro ao carregar os planos - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  }

  useEffect(() => {
    getPlanInfo();
  }, []);

  useEffect(() => {
    const search = window.location.search;

    const path = window.location.pathname;
    const pathParts = path.split('/');
    const id = pathParts[pathParts.length - 1];

    if (infoPlans.length > 0) {
        if (isCheckoutPath && checkoutPlanId) {
            const checkoutPlan = infoPlans.find(
              (plano) => plano.id === checkoutPlanId
            );
            const selectedCheckoutPlan = checkoutPlan
              ? { value: checkoutPlan.id, label: checkoutPlan.plan_name }
              : { value: checkoutPlanId, label: checkoutPlanFallbackLabel || `PLANO ${checkoutPlanId}` };
            setSelectedPlanType("anual");
            setPathnamePlanId(selectedCheckoutPlan.value);
            setPlanSeleted(selectedCheckoutPlan);
            setPlans(selectedCheckoutPlan);
            return;
        }

        let planId = null;
        
        if ((search && search.length > 1) || id) { 
            try {
                const query = search.substring(1);

                const idParam = query.split('&')[0]; 
                
                planId = Number(idParam) ? Number(idParam) : Number(id);
                
                if (isNaN(planId)) {
                    const params = new URLSearchParams(search);
                    planId = Number(params.get('id')); 
                }
            } catch (error) {}
        }

        if (planId && !isNaN(planId)) {
            setPathnamePlanId(planId);

            const planosDisponiveis = infoPlans.map(plano => ({
                value: plano.id,
                label: plano.plan_name
            }));
            
            const planoEncontrado = planosDisponiveis.find(plano => plano.value === planId);
            
            if (planoEncontrado) {
                if (
                  planoEncontrado.value === 4 ||
                  planoEncontrado.value === 5 ||
                  planoEncontrado.value === 7 
                ) {
                    setSelectedPlanType("anual");
                } else {
                    setSelectedPlanType("mensal");
                }
                setPlanSeleted(planoEncontrado);
                setPlans({ value: planoEncontrado.value, label: planoEncontrado.label });
            } else {
                resetPlans();
            }
        } else {
            resetPlans();
        }
    }

    function resetPlans() {
        setPlanSeleted({});
        setPlans({ value: '', label: '' });
        setPathnamePlanId(0); 
    }
  }, [infoPlans, isCheckoutPath, checkoutPlanId, checkoutPlanFallbackLabel]);

  useEffect(() => {
    setAcordionPlanError(acordionError);

    setHasError({
      selectedPlan: hasErrorSelect,
      userCount: hasErrorUsers,
      revenues: hasErrorRevenues,
    });
  }, [acordionError, hasErrorSelect, hasErrorUsers, hasErrorRevenues]);

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "0,00";

    let numberValue;
    if (typeof value === "string") {
      const cleanValue = value.replace(/\./g, "").replace(",", ".");
      numberValue = parseFloat(cleanValue);
    } else {
      numberValue = Number(value);
    }

    if (isNaN(numberValue)) return "0,00";

    return numberValue.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Arredonda exibindo os centavos para a dezena mais baixa quando a unidade dos centavos é 0–4.
  // Exemplos: 79,92 -> 79,90 | 183,94 -> 183,90 | 183,95 -> 183,95
  const roundCentsUnitsDownForDisplay = (value) => {
    if (value === null || value === undefined || value === "") return "0,00";

    let numericValue;
    if (typeof value === "number") {
      numericValue = value;
    } else if (typeof value === "string") {
      const normalized = value.replace(/\./g, "").replace(",", ".");
      const parsed = parseFloat(normalized);
      if (isNaN(parsed)) return value;
      numericValue = parsed;
    } else {
      return "0,00";
    }

    const fixed = numericValue.toFixed(2); // '123.45'
    const [intPart, decPart] = fixed.split(".");
    const tens = decPart.charAt(0);
    const units = decPart.charAt(1);

    let newNumericValue;
    if (Number(units) <= 4) {
      // Mantém a dezena dos centavos e zera a unidade dos centavos
      newNumericValue = parseInt(intPart, 10) + Number(tens) / 10;
    } else {
      newNumericValue = parseFloat(fixed);
    }

    return newNumericValue.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const applyPercentageDiscount = (value, percentage) => {
    if (!percentage) return value;
    
    const numericValue =
    typeof value === "string"
        ? parseFloat(value.replace(".", "").replace(",", "."))
        : Number(value);

    const discountedValue = numericValue * (1 - percentage / 100);
    
    return formatCurrency(discountedValue);
  };

  const getPlanId = async () => {
    try {
      const response = await api.get(`/planos/${pathnamePlanId}`);

      setPlan(response.data.data);
      setHasCupom(true);
    } catch (error) {}
  };

  useEffect(() => {
    if (plans.value) {
      setUsers(1);

      setRevenues(50);

      setHasSelectedPlan(true);
    }
  }, [plans]);

  useEffect(() => {
    setHasError(prev => {
      const newState = {...prev};
      
      if(users > 0) {
        newState.userCount = false;
      }
  
      if(revenues > 0) {
        newState.revenues = false;
      }
      
      return newState;
    });
  }, [users, revenues]);

  useEffect(() => {
    getPlanId();
  }, [pathnamePlanId]);

  // A API devolve o enum Recorrencia (ANUAL/MENSAL) ou null - normaliza para não
  // depender de casing/espaços na comparação.
  const normalizeRecorrencia = (value) =>
    typeof value === "string" && value.trim() ? value.trim().toUpperCase() : null;

  // Só envia o cupom para o parent (e, portanto, para o backend) quando a
  // validação no front aceitar. Em erro ou campo vazio, envia string vazia.
  const notifyCouponToParent = (validatedCupom) => {
    if (typeof onCouponChanged === "function") {
      onCouponChanged(validatedCupom ? String(validatedCupom).toUpperCase() : "");
    }
  };

  const clearValidatedCoupon = () => {
    setCupomValue(null);
    setCupomInfo("");
    setDiscountMonths(0);
    setCupomRecorrencia(null);
    if (typeof onCupomRecorrenciaChanged === "function") onCupomRecorrenciaChanged(null);
    notifyCouponToParent("");
  };

  const validaCupom = async (cupomInput, id) => {
    try {
      setHasErrorCupom(false);

      if (!cupomInput && !cupom){
        clearValidatedCoupon();
        return;
      }
      let cupomInfo = cupomInput || cupom.toLocaleUpperCase()

      setHasErrorCupom(false);

      let idPlanNumber = parseInt(id)

      const payload = {
        cupom: cupomInfo.toLocaleUpperCase(),
        plano: idPlanNumber ? idPlanNumber : IdPlans,
      };

      if (window.location.pathname.includes("/checkout")) {
        const response = await api.post(`/planos/valida/cupom-protheus`, payload);

        if (response.data && response.data.data) {
          setCupomInfo(response.data.data.desconto || "");
          setCupomValue(response.data.data.desconto_value || null);
          setDiscountMonths(response.data.data.meses_desconto || 0);
          notifyCouponToParent(cupomInfo);
        } else {
          clearValidatedCoupon();
        }
      } else if (window.location.pathname.includes("/simulacaoplano")) {
        const response = await api.post(`/simulacaoplanos/valida/cupom`, payload);

        if (response.data && response.data.data) {
          setCupomInfo(response.data.data.desconto || "");
          setCupomValue(response.data.data.desconto_value || null);
          setDiscountMonths(response.data.data.meses_desconto || 0);

          const recorrencia = normalizeRecorrencia(response.data.data.recorrencia);

          setCupomRecorrencia(recorrencia);
          if (typeof onCupomRecorrenciaChanged === 'function') onCupomRecorrenciaChanged(recorrencia);
          notifyCouponToParent(cupomInfo);
        } else {
          clearValidatedCoupon();
        }
      } else if (window.location.pathname.includes("/simulacaoplano")) {
        const response = await api.post(`/simulacaoplanos/valida/cupom`, payload);

        if (response.data && response.data.data) {
          setCupomInfo(response.data.data.desconto || "");
          setCupomValue(response.data.data.desconto_value || null);
          setDiscountMonths(response.data.data.meses_desconto || 0);

          const recorrencia = normalizeRecorrencia(response.data.data.recorrencia);

          setCupomRecorrencia(recorrencia);
          if (typeof onCupomRecorrenciaChanged === 'function') onCupomRecorrenciaChanged(recorrencia);
        } else {
          setCupomValue(null);
          setCupomInfo("");
          setDiscountMonths(0);
          setCupomRecorrencia(null);
          if (typeof onCupomRecorrenciaChanged === 'function') onCupomRecorrenciaChanged(null);
        }
      } else {
      const response = await api.post(`/planos/valida/cupom`, payload);

      if (response.data && response.data.data) {
        setCupomInfo(response.data.data.desconto || "");
        setCupomValue(response.data.data.desconto_value || null);
        setDiscountMonths(response.data.data.meses_desconto || 0);

        const recorrencia = normalizeRecorrencia(response.data.data.recorrencia);

        setCupomRecorrencia(recorrencia);
        if (typeof onCupomRecorrenciaChanged === 'function') onCupomRecorrenciaChanged(recorrencia);
        notifyCouponToParent(cupomInfo);
      } else {
        clearValidatedCoupon();
      }
      }
    } catch (error) {
      clearValidatedCoupon();

      if (cupom) {
        setHasErrorCupom(true);

        // Verifica se o erro tem a estrutura esperada
        const errorMessage = error?.response?.data?.errors 
                          || error?.message 
                          || 'Erro ao validar cupom';

        store.addNotification({
          title: "Erro!",
          message: `${errorMessage}`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      }
    }
  };

  const getInfoPlans = async () => {
    try {
      const response = await api.get(`/planos/${IdPlans}`);

      if (response) {
        setPlan(response.data.data);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    const newId = Number(plans.value);
    setIdPlans(newId);
  }, [plans]);

  useEffect(() => {
    if (IdPlans > 0) {
      getInfoPlans();
    }
  }, [IdPlans]);

  useEffect(() => {
    const search = window.location.search;

    const path = window.location.pathname;

    const pathParts = path.split('/');
    const id = pathParts[pathParts.length - 1];

    if (infoPlans.length > 0 || id) {
      if ((search && search.length > 1) || id) { 
        try {
            const query = search.substring(1);
            const idParam = query.split('&')[0]; 
            
            if (idParam === "6" || id === "6") {
              setSelectedPlanType("prePago")
            }
        } catch (error) {}
      }
    }
  }, [infoPlans]);

  const isPrePago = String(plans.value) === "6";

  // PLANO BASIC permite apenas 1 usuário: campo fixo em 1 e bloqueado.
  const isBasic = String(plans.value) === "7" || plans.label === "PLANO BASIC";
  const isUserCountLocked = isUserCountDisabled || isBasic;

  useEffect(() => {
    if (isBasic && users !== 1) {
      setUsers(1);
    }
  }, [isBasic, users]);

  const getPlanValues = (count) => {
    if (!plan.length || !plan[0].plans_grid)
      return { anual: "0,00", mensal: "0,00", prePago: "0,00" };

    const adjustedCount = !count || count < 1 ? 1 : count;

    if (isPrePago) {
      const sortedPrePagoPlans = [...plan[0].plans_grid].sort(
        (a, b) => a.qtd_users - b.qtd_users
      );
      let selectedPrePagoPlan = sortedPrePagoPlans[0];

      for (const plan of sortedPrePagoPlans) {
        if (adjustedCount >= plan.qtd_users) {
          selectedPrePagoPlan = plan;
        } else {
          break;
        }
      }

      return {
        prePago: selectedPrePagoPlan.vlr_unit,
        effectiveCount: adjustedCount,
        anual: "0,00",
        mensal: "0,00",
        prePagoRange: selectedPrePagoPlan.qtd_users,
      };
    }

    const anualPlan = plan[0].plans_grid.find(
      (grid) => grid.renew_type_id === 4 && grid.qtd_users === adjustedCount
    );

    const mensalPlan = plan[0].plans_grid.find(
      (grid) => grid.renew_type_id === 2 && grid.qtd_users === adjustedCount
    );

    const findClosestPlan = (typeId) => {
      const filtered = plan[0].plans_grid.filter(
        (grid) => grid.renew_type_id === typeId
      );
      if (filtered.length === 0) return null;

      filtered.sort((a, b) => a.qtd_users - b.qtd_users);
      return filtered[filtered.length - 1];
    };

    return {
      anual: anualPlan
        ? anualPlan.vlr_unit
        : findClosestPlan(4)?.vlr_unit || "0,00",
      mensal: mensalPlan
        ? mensalPlan.vlr_unit
        : findClosestPlan(2)?.vlr_unit || "0,00",
      prePago: "0,00",
      effectiveCount: adjustedCount,
      prePagoRange: null,
    };
  };

  const planValues = isPrePago ? getPlanValues(revenues) : getPlanValues(users);
  const effectiveCount = planValues.effectiveCount;

    // Evitar loops: armazenar últimos valores enviados aos callbacks
  const prevValueMonthRef = useRef(null);
  const prevPerMonthRef = useRef(null);
  const prevMonthNoDiscountRef = useRef(null);
  const prevMonthWithDiscountRef = useRef(null);
  const prevAnnualNoDiscountTotalRef = useRef(null);
  const prevFullValueForUsersRef = useRef(null);
  const prevPrePagoRef = useRef(null);
  const prevFullValueAnualRef = useRef(null);
  const prevValueAnualRef = useRef(null);
  
  // Arredonda valor para centavos terminando em 0 ou 5
  const roundCentsToZeroOrFive = (num) => {
    const cents = Math.round(num * 100);
    const last = cents % 10;
    const base = cents - last;
    let newCents;
    if (last > 5) {
      newCents = base + 10;
    } else if (last < 5) {
      newCents = base;
    } else {
      newCents = base + 5;
    }
    return newCents / 100;
  };

  const calculateMonthlyFromAnnual = (annualValue) => {
    if (!annualValue) return "0,00";
    const monthly = parseFloat(annualValue.replace(",", ".")) / 12;
    return formatCurrency(monthly);
  };

const calculateMonthlyForUser = (monthValue) => {
  if (!monthValue || isNaN(users) || users < 1) {
    return "0,00";
  }

  try {
    let valueMensalCupom;

    if (cupom && cupom === "BEMVINDO") {
      valueMensalCupom = roundCentsUnitsDownForDisplay(planValues.mensal).toString()
        .replace(/\./g, '')
        .replace(',', '.');
    } else {
      valueMensalCupom = roundCentsUnitsDownForDisplay(applyPercentageDiscount(planValues.mensal, cupomValue))
        .toString()
        .replace(/\./g, '')
        .replace(',', '.');
    }
  
      const convertedValueMensalCupom = parseFloat(valueMensalCupom);
  
      const total = convertedValueMensalCupom * users;
      const roundedTotal = roundCentsToZeroOrFive(total);
  
      const formattedResult = formatCurrency(roundedTotal);
    
      return formattedResult;
    } catch (error) {
      return "0,00";
    }
  };

  const calculateMonthlyForUserWithCupom = (monthValue) => {
    if (!monthValue || isNaN(users) || users < 1) {
      return "0,00";
    }

    try {
      let valueMensalCupom;

      if (cupom && cupom === "BEMVINDO") {
        valueMensalCupom = planValues.mensal.toString()
          .replace(/\./g, '')
          .replace(',', '.');
      } else {
        valueMensalCupom = (cupomAplicaMensal ? applyPercentageDiscount(planValues.mensal, cupomValue) : planValues.mensal)
          .toString()
          .replace(/\./g, '')
          .replace(',', '.');
      }
  
      const convertedValueMensalCupom = parseFloat(valueMensalCupom);
  
      const total = convertedValueMensalCupom * users;
      const roundedTotal = roundCentsToZeroOrFive(total);
  
      const formattedResult = formatCurrency(roundedTotal);

      return formattedResult;
    } catch (error) {
      return "0,00";
    }
  };

  const calculateAnnualWithDiscount = () => {
    try {
      const numericAnnualUnit = parseFloat(planValues.anual.replace(/\./g, '').replace(',', '.'));
      const monthlyValue = calculateMonthlyFromAnnual(planValues.anual);
      const numericMonthly = parseFloat(monthlyValue.replace(/\./g, '').replace(',', '.'));
      if (!cupomAplicaAnual) {
        const fallback = numericAnnualUnit * effectiveCount;
        return formatCurrency(fallback);
      }
      const monthsToDiscount = discountMonths === 0 ? 12 : Math.min(discountMonths, 12);
      const preciseMonthly = Math.round(numericMonthly * 100) / 100;
      const preciseDiscount = Math.round((1 - cupomValue / 100) * 100) / 100;
      
      const monthlyDiscountedValue = Math.round((preciseMonthly * preciseDiscount) * 100) / 100;

      const discountedValue = monthlyDiscountedValue * monthsToDiscount;

      const remainingMonths = 12 - monthsToDiscount;
      const fullPriceValue = remainingMonths > 0 ? preciseMonthly * remainingMonths : 0;

      const total = (discountedValue + fullPriceValue) * effectiveCount;

      return formatCurrency(total);
    } catch (error) {
      const fallbackValue = parseFloat(planValues.anual.replace(/\./g, '').replace(',', '.')) * effectiveCount;
      return formatCurrency(fallbackValue);
    }
  };

  useEffect(() => {
    if (plans.value && onPlanSelected) {
      onPlanSelected({ value: plans.value, label: plans.label });
    }
  }, [plans]);

  useEffect(() => {
    if (onUsersCountChanged) {
      onUsersCountChanged(users);
    }
  }, [users]);

  useEffect(() => {
    if (!cupom) {
      notifyCouponToParent("");
    }
  }, [cupom]);

  useEffect(() => {
    if (onRevenuesChanged) {
      onRevenuesChanged(revenues);
    }
  }, [revenues]);

  useEffect(() => {
    let plano = selectedPlanType

    if (onValueMonth && planValues) {
      onValueMonth(planValues.mensal);
    }
    
    if (onValuePerMonthChanged && planValues) {
      const monthlyValue = plano === "anual" 
        ? calculateMonthlyFromAnnual(planValues.anual)
        : plano === "mensal" 
          ? planValues.mensal 
          : planValues.prePago;
      
      const canApply =
        (plano === "anual" && cupomAplicaAnual) ||
        (plano === "mensal" && cupomAplicaMensal) ||
        (plano !== "anual" && plano !== "mensal" && cupomAplicaPrePago);

      const finalValue = canApply
        ? applyPercentageDiscount(monthlyValue, cupomValue)
        : monthlyValue;

      onValuePerMonthChanged(roundCentsUnitsDownForDisplay(finalValue));
    }
  }, [planValues, selectedPlanType, cupomValue, cupomRecorrencia, onValuePerMonthChanged, onValueMonth]);

    useEffect(() => {
      if (typeof onValueRevenuesPrePagoChanged === 'function' && typeof onValueRevenuesPrePagoWithNotDiscount === 'function') {
        if (cupomAplicaPrePago) {
          onValueRevenuesPrePagoChanged(applyPercentageDiscount(planValues.prePago, cupomValue));
          onValueRevenuesPrePagoWithNotDiscount(planValues.prePago);
        } else {
          onValueRevenuesPrePagoChanged(planValues.prePago);
          onValueRevenuesPrePagoWithNotDiscount(planValues.prePago);
        }
      }
    }, [planValues, onValueRevenuesPrePagoChanged, onValueRevenuesPrePagoWithNotDiscount, cupomValue]);

    useEffect(() => {
      if (onMessageCupomChanged) {
        onMessageCupomChanged(cupomInfo);
      }
    }, [cupomInfo, onMessageCupomChanged]);

    useEffect(() => {
       let plano = selectedPlanType

      if (onFullValueMonthNotDiscountChanged && planValues) {
        const monthlyValueWithoutDiscount = plano === "anual" 
          ? calculateMonthlyFromAnnual(planValues.anual)
          : planValues.mensal;
        
          onFullValueMonthNotDiscountChanged(monthlyValueWithoutDiscount);
      }
    }, [planValues, selectedPlanType, onFullValueMonthNotDiscountChanged]);

    useEffect(() => {
      if (onFullValueMonthWithDiscountChanged && planValues) {
        let plano = selectedPlanType;
        
        const monthlyValue = plano === "anual" 
          ? calculateMonthlyFromAnnual(planValues.anual)
          : planValues.mensal;
        
        const canApply =
          (plano === "anual" && cupomAplicaAnual) ||
          (plano === "mensal" && cupomAplicaMensal) ||
          (plano !== "anual" && plano !== "mensal" && cupomAplicaPrePago);

        const discountedValue = canApply
          ? applyPercentageDiscount(monthlyValue, cupomValue)
          : monthlyValue;
        
          onFullValueMonthWithDiscountChanged(roundCentsUnitsDownForDisplay(discountedValue));
        } 
      }, [planValues, selectedPlanType, cupomValue, cupomRecorrencia, onFullValueMonthWithDiscountChanged]);

    useEffect(() => {
      if (onFullValueAnual && planValues && selectedPlanType === "anual") {
        if (cupomAplicaAnual) {
          onFullValueAnual(calculateAnnualWithDiscount());
          onValueAnual(formatCurrency(
            parseFloat(planValues.anual.replace(",", "."))
          ))
        } else {
          onFullValueAnual(formatCurrency(
            parseFloat(planValues.anual.replace(",", ".")) * effectiveCount
          ))
          onValueAnual(formatCurrency(
            parseFloat(planValues.anual.replace(",", "."))
          ))
        }
      } else if (onFullValueAnual && onValueAnual) {
        onFullValueAnual(null);
        onValueAnual(null)
      }
    }, [planValues, onFullValueAnual, selectedPlanType, onValueAnual]);

    useEffect(() => {
      if (onFullValueNotDiscountAnual && planValues && planValues.anual) {
        const anualValue = parseFloat(planValues.anual.replace(",", ".")) * effectiveCount;
        onFullValueNotDiscountAnual(anualValue);
      }
    }, [planValues.anual, effectiveCount, onFullValueNotDiscountAnual]);

    // useEffect(() => {
    //   if (plans.value === "6") {
    //     setCupom("");
    //     setCupomValue(0);
    //     setCupomInfo("");
    //     setDiscountMonths(0);
    //   }
    // }, [plans.value]);
    
    const previousPlanRef = useRef(null); 

    useEffect(() => {
      previousPlanRef.current = plans.value;
    }, []);

  useEffect(() => {
    if (plan.length && plan[0].plans_grid) {
      const ids = plan[0].plans_grid.map(obj => obj.id);
      setPrecoIds(ids);
    }
  }, [plan]);

  useEffect(() => {
    if (plan.length && plan[0].plans_grid) {
      const adjustedCount = !users || users < 1 ? 1 : users;
      let selectedIdGrid = null;
      let selectedIdPlan = null;
      let plano = selectedPlanType

      if (plans.label === "PLANO PRÉ-PAGO") {
        plano = "prePago"
      }

      if (plano === "anual") {
        let anualPlan = plan[0].plans_grid.find(
          grid => grid.renew_type_id === 4 && grid.qtd_users === adjustedCount
        );       
        if (!anualPlan) {
          const filtered = plan[0].plans_grid.filter(grid => grid.renew_type_id === 4);
        
          if (filtered.length > 0) {
            filtered.sort((a, b) => a.qtd_users - b.qtd_users);
            anualPlan = filtered[filtered.length - 1];
          }
        }

        selectedIdGrid = anualPlan ? anualPlan.id : null;
        selectedIdPlan = anualPlan ? anualPlan.plan_id : null;
      } else if (plano === "mensal") {
        let mensalPlan = plan[0].plans_grid.find(
          grid => grid.renew_type_id === 2 && grid.qtd_users === adjustedCount
        );
       
        if (!mensalPlan) {
          const filtered = plan[0].plans_grid.filter(grid => grid.renew_type_id === 2);
        
          if (filtered.length > 0) {
            filtered.sort((a, b) => a.qtd_users - b.qtd_users);
            mensalPlan = filtered[filtered.length - 1];
         }
        }
        
        selectedIdGrid = mensalPlan ? mensalPlan.id : null;
        selectedIdPlan = mensalPlan ? mensalPlan.plan_id : null;
      } else if (plano === "prePago") {
        let planSelect = plan[0].plans_grid.find(
          grid => grid.renew_type_id === 1 && grid.qtd_users === revenues
        );

        selectedIdGrid = planSelect ? planSelect.id : null;
        selectedIdPlan = planSelect ? planSelect.plan_id : null;
      }
      
      if (selectedIdGrid !== null) {
        if (onIdPlanGridCard) {
          onIdPlanGridCard(selectedIdGrid);
        }

        if (onIdPlanCard) {
          onIdPlanCard(selectedIdPlan);
        }
      }
    }
  }, [selectedPlanType, plan, users, onIdPlanGridCard]);

  // useEffect(() => {
  //   if (discountMonths) {
  //       onDiscountMonths(discountMonths);
  //     }
  // }, [discountMonths, onDiscountMonths]);

  useEffect(() => {
    if (discountMonths && typeof onDiscountMonths === 'function') {
      onDiscountMonths(discountMonths);
    }
  }, [discountMonths, onDiscountMonths]);

  // Preços que cada card realmente mostra na tela - espelham a mesma formatação do JSX.
  // Servem para esconder o badge quando o anual sai mais caro que o mensal (ex.: cupom
  // exclusivo do MENSAL derruba o mensal abaixo do anual: 183,90 > 160,90).
  const valorAnualExibido = brlToNumber(
    cupomAplicaAnual
      ? applyPercentageDiscount(calculateMonthlyFromAnnual(planValues.anual), cupomValue)
      : roundCentsUnitsDownForDisplay(calculateMonthlyFromAnnual(planValues.anual))
  );

  const valorMensalExibido = brlToNumber(
    cupomAplicaMensal
      ? roundCentsUnitsDownForDisplay(applyPercentageDiscount(planValues.mensal, cupomValue))
      : roundCentsUnitsDownForDisplay(planValues.mensal)
  );

  const anualMaisCaroQueMensal =
    valorMensalExibido > 0 && valorAnualExibido >= valorMensalExibido;

  useEffect(() => {
    // Badge do card Anual = quanto o anual é mais barato que o mensal.
    // Quando o cupom vale para as duas recorrências (ex.: BEMVINDO) o desconto se anula
    // na razão, então só aplicamos o cupom aqui quando ele é exclusivo do ANUAL.
    // Ex.: BEMVINDO 90% -> (1 - 18,39/22,99) = (1 - 183,90/229,90) = 20%.
    const valueAnual = brlToNumber(calculateMonthlyFromAnnual(planValues.anual));
    const valueMensal = brlToNumber(planValues.mensal);

    const valueAnualComparado =
      cupomAplicaAnual && !cupomAplicaMensal
        ? valueAnual * (1 - cupomValue / 100)
        : valueAnual;

    // Epsilon evita que um desconto exato (ex.: 20%) caia para 19% por imprecisão de float.
    const calculo =
      valueMensal > 0
        ? Math.floor(((1 - (valueAnualComparado / valueMensal)) * 100) + 1e-9)
        : 0;

    setPercentageApplied(calculo > 0 ? calculo : 0);

  }, [planValues, cupomValue, cupomAplicaAnual, cupomAplicaMensal]);


  useEffect(() => {
    if (Array.isArray(plan) && plan.length > 0) {
      const documentsLimit = plan[0].documents_limit ?? null;
      const prescriptionsLimit = plan[0].prescriptions_limit ?? null;
  
      setQtdPrescriptions(prescriptionsLimit);
      setQtdDocuments(documentsLimit);
  
      if (typeof onQtdDocuments === 'function') {
        onQtdDocuments(documentsLimit);
      }
      if (typeof onQtdPrescriptions === 'function') {
        onQtdPrescriptions(prescriptionsLimit);
      }
    }
  }, [plan, onQtdDocuments, onQtdPrescriptions]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const getParamPreservePlus = (name) => {
      const regex = new RegExp(`[?&]${name}=([^&]*)`);
      const match = queryString.match(regex);
      if (match && typeof match[1] === 'string') {
        try {
          return decodeURIComponent(match[1].replace(/\+/g, '%2B'));
        } catch (e) {
          return match[1];
        }
      }
      return "";
    };

    const cupomRaw = getParamPreservePlus('cupom');
    const buttonRaw = getParamPreservePlus('button') || urlParams.get('button') || "";

    setUtmParam({
      utm_campaign: urlParams.get('utm_campaign') || "",
      utm_id: Number(urlParams.get('utm_id')) || 0,
      utm_medium: urlParams.get('utm_medium') || "",
      utm_source: urlParams.get('utm_source') || "",
      cupom: cupomRaw || "",
      button: buttonRaw || "",
    });
  }, []);

  useEffect(() => {
    if(utmParam.cupom) {
      const cupomUrl = utmParam.cupom.toUpperCase();

      setCupom(cupomUrl)

      if (hasCupom === true) {
        validaCupom(cupomUrl.trim())
      }
    }
  }, [utmParam, hasCupom]);

  // Usuário veio do site institucional (button="site-...") sem cupom explícito na URL:
  // se o plano escolhido estiver em promoção na campanha ativa, aplica o cupom da campanha automaticamente.
  // Na tela de simulação o cupom só deve vir da URL (?cupom=) ou de digitação manual, nunca desse auto-apply.
  useEffect(() => {
    if (window.location.pathname.includes("/simulacaoplano")) return;
    if (utmParam.cupom) return;
    if (!utmParam.button || !utmParam.button.startsWith('site')) return;
    if (!activeCampaign || !pathnamePlanId) return;

    const campaignPlan = activeCampaign.agro_campaign_plans?.find(
      (p) => p.agro_plan_id === pathnamePlanId
    );
    const cupomCampanha = campaignPlan ? activeCampaign.agro_coupon?.nome_cupom : null;

    if (cupomCampanha) {
      const cupomCampanhaUpper = cupomCampanha.toUpperCase();

      setCupom(cupomCampanhaUpper);
      setCupomFromCampaign(true);

      if (hasCupom === true) {
        validaCupom(cupomCampanhaUpper.trim());
      }
    }
  }, [utmParam, activeCampaign, pathnamePlanId, hasCupom]);

  // Mantém o cupom da campanha em sincronia com o plano selecionado no
  // dropdown "Escolha seu plano": ao trocar para um plano contemplado pela
  // campanha ativa, aplica o cupom automaticamente; ao trocar para um plano
  // fora da campanha, remove o cupom que havia sido aplicado automaticamente
  // (nunca sobrescreve/limpa um cupom digitado manualmente pelo usuário).
  // Retorna true quando já tratou o cupom para o plano informado (aplicou ou
  // removeu o cupom da campanha), sinalizando ao chamador que não precisa
  // repetir a validação do cupom por conta própria.
  const syncCupomWithCampaignForPlan = (planId) => {
    // Na tela de simulação o cupom só pode vir da URL (?cupom=) ou de digitação
    // manual pelo usuário — nunca aplicado/removido automaticamente pela campanha.
    if (window.location.pathname.includes("/simulacaoplano")) return false;
    if (!activeCampaign) return false;

    const campaignPlan = activeCampaign.agro_campaign_plans?.find(
      (p) => p.agro_plan_id === Number(planId)
    );
    const cupomCampanha = campaignPlan
      ? activeCampaign.agro_coupon?.nome_cupom
      : null;

    const cupomEhDaCampanhaOuVazio = !cupom || cupomFromCampaign;
    if (!cupomEhDaCampanhaOuVazio) return false;

    if (cupomCampanha) {
      const cupomCampanhaUpper = cupomCampanha.toUpperCase();

      setCupom(cupomCampanhaUpper);
      setCupomFromCampaign(true);

      if (hasCupom === true) {
        validaCupom(cupomCampanhaUpper.trim(), planId);
      }

      return true;
    } else if (cupomFromCampaign) {
      setCupom("");
      setCupomValue(null);
      setCupomInfo("");
      setDiscountMonths(0);
      setCupomRecorrencia(null);
      setCupomFromCampaign(false);
      if (typeof onCupomRecorrenciaChanged === 'function') onCupomRecorrenciaChanged(null);

      return true;
    }

    return false;
  };

  //Função aqui
// Função separada para calcular o valor
const calculatePlanValue = (planValue, count, discount = null) => {
  const baseValue = parseFloat(planValue.replace(",", ".")) * count;
  
  if (discount) {
    return applyPercentageDiscount(baseValue, discount);
  }
  
  return formatCurrency(baseValue);
};

  // Opções de plano filtradas para usuários TOTVS (somente PROTHEUS)
  // const planOptions = (
  //   isTotvs()
  //     ? infoPlans.filter(
  //         (plan) => plan.plan_name?.toUpperCase() === "PLANO PROTHEUS" || plan.id === 9
  //       )
  //     : infoPlans
  // ).map((plan) => ({ value: plan.id, label: plan.plan_name }));

  // Define automaticamente o plano PROTHEUS para usuários TOTVS, se disponível
  // useEffect(() => {
  //   const protheusPlan = infoPlans.find(
  //     (p) => p.plan_name?.toUpperCase() === "PLANO PROTHEUS" || p.id === 9
  //   );
    
  //   if (protheusPlan) {
  //     const payload = { value: protheusPlan.id, label: protheusPlan.plan_name };
  //     setPlans(payload);
  //     setPlanSeleted(payload);
  //     if (typeof onPlanSelected === "function") onPlanSelected(payload);
  //   }
  // }, [infoPlans, onPlanSelected]);

   // Calcula o total sem desconto para a quantidade de usuários
  useEffect(() => {
    if (typeof onFullValueForUsersChanged === 'function' && planValues) {
      let plano = selectedPlanType;

      if (plans.label === "PLANO BASIC") {
        plano = "anual";
      }

      let total = null;
      try {
        if (plano === "anual" && planValues.anual) {
          const anualUnit = parseFloat(String(planValues.anual).replace(/\./g, '').replace(',', '.'));
          total = anualUnit * effectiveCount;
        } else if (plano === "mensal" && planValues.mensal) {
          const mensalUnit = parseFloat(String(planValues.mensal).replace(/\./g, '').replace(',', '.'));
          total = mensalUnit * effectiveCount;
        }
      } catch (_) {
        total = null;
      }

      const formatted = total !== null ? formatCurrency(total) : null;
      if (formatted !== prevFullValueForUsersRef.current) {
        onFullValueForUsersChanged(formatted);
        prevFullValueForUsersRef.current = formatted;
      }
    }
  }, [planValues.mensal, planValues.anual, selectedPlanType, effectiveCount, plans.label, onFullValueForUsersChanged]);

  return (
    <S.ContainerContentSimulation>
      <S.ContentSimulation acordionError={acordionPlanError}>
        <H6 color={theme.colors.gray.Cinza_2}>
          {isPartnerCheckout
            ? "Escolha o Plano"
            : window.location.pathname.includes("/simulacaoplano") ? "Simule seu plano" : "Escolha seu plano"}
        </H6>
        
        <S.Divider />

        <S.ContainerInputs extraInfo={cupomInfo}>
          {isPartnerCheckout ? (
            <InputV3
              id="parceiro"
              type="text"
              label="Parceiro"
              floatingLabelWithAsterisk="Parceiro"
              value={selectedPartner?.label || ""}
              onChange={() => {}}
              isDisabled={true}
              hasError={hasErrorPartner}
            />
          ) : (
          <InputV3
            id="planos"
            type="select"
            typeValueSelect="string"
            floatingLabelWithAsterisk="Escolha seu plano"
            value={plans.value ? plans : ""} 
            onChange={(selectedOption) => {
              setPlans({
                value: selectedOption.value,
                label: selectedOption.label,
              });

              setPlanSeleted({
                value: selectedOption.value,
                label: selectedOption.label,
              })

              if (previousPlanRef.current === "6") {
                setCupom("");
                setCupomFromCampaign(false);
                clearValidatedCoupon();
              }

              const cupomSincronizadoPelaCampanha = syncCupomWithCampaignForPlan(selectedOption.value);

              if (!cupomSincronizadoPelaCampanha && selectedOption.value && cupom) {
                validaCupom(cupom, selectedOption.value)
              }

              setHasError({
                ...hasError,
                selectedPlan: false,
              });

              if (selectedOption.value !== null && selectedOption.value !== 0 &&
                users !== null && users !== 0
              ) {
                setAcordionPlanError(false);
              }

              if ((selectedOption.value === 4 || selectedOption.value === "4") || 
              (selectedOption.value === 5 || selectedOption.value === "5") || 
              (selectedOption.value === 7 || selectedOption.value === "7")) {
                setSelectedPlanType("anual")
              }
            }}
            options={
              isCheckoutPath
                ? [checkoutPlanDefault]
                : [
                    { value: 6, label: "PLANO PRÉ-PAGO" },
                    { value: 7, label: "PLANO BASIC" },
                    { value: 4, label: "PLANO LIGHT" },
                    { value: 5, label: "PLANO PRO" },
                  ]
            }
            hasError={hasError.selectedPlan}
            floatingValue={planSeleted?.label || ""} 
          />
          )}

          <InputV3
            id="cupom"
            type="text"
            label="Cupom de descontos"
            floatingLabel="Cupom de descontos"
            value={cupom}
            onChange={(e) => {
              const newValue = e.target.value.trim().toUpperCase();
              setCupom(newValue);
              setCupomFromCampaign(false);

              setHasErrorCupom(false);
              // Cupom editado ainda não foi revalidado — não envia para o backend.
              notifyCouponToParent("");
            }}
            hasError={hasErrorCupom}
            extraInfo={cupomInfo ? cupomInfo : ""}
            onBlur={() => validaCupom(cupom.trim())}
            handleClear={() => {
              setCupom("");
              setCupomFromCampaign(false);
              setHasErrorCupom(false);
              clearValidatedCoupon();
            }}
          />

          {isPrePago ? (
            <InputV3
              id="receitas"
              type="text"
              label="Quantidade de receitas"
              floatingLabelWithAsterisk="Quantidade de receitas"
              value={revenues}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                const value = numericValue === "" ? "" : Number(numericValue);
                setRevenues(value);

                setHasError({
                  ...hasError,
                  revenues: false,
                });

                if (plans.value !== null && plans.value !== "" && value > 0) {
                  setAcordionPlanError(false);
                }
              }}
              onKeyDown={(e) => {
                if (!/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              inputMode="numeric"
              onBlur={() => {
                if ((isClearRevenues === false || isClearRevenues === true) && (revenues === "" || revenues < 50)) {
                  setRevenues(50);
                }
              }}
              hasError={hasError.revenues}
              min="50"
              handleClear={() => {
                setRevenues(0)
                setIsClearRevenues(true)
              }}
            />
          ) : (
            <InputV3
              id="usuarios"
              type="text"
              label="Quantidade de usuários"
              floatingLabelWithAsterisk="Quantidade de usuários"
              value={users}
              onChange={(e) => {
                if (isUserCountLocked) return;

                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                const value = numericValue === "" ? "" : Number(numericValue);
                setUsers(value);

                setHasError({
                  ...hasError,
                  userCount: false,
                });

                if (plans.value !== null && plans.value !== "" && value > 0) {
                  setAcordionPlanError(false);
                }
              }}
              onKeyDown={(e) => {
                if (!/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              inputMode="numeric"
              onBlur={() => {
                if (isClearUsers === false && (users === "" || users < 1)) {
                  setUsers(1);
                }
              }}
              hasError={hasError.userCount}
              min="1"
              handleClear={() => {
                if (isUserCountLocked) return;

                setUsers(0)
                setIsClearUsers(true)
              }}
              isDisabled={isUserCountLocked}
              extraInfo={isBasic ? "O Plano Basic permite apenas 1 usuário." : ""}
            />
          )}

          {hasSelectedPlan && effectiveCount > 0 && (
            <S.ContainerCardPlans as="form" isPrePago={isPrePago}>
              {isPrePago ? (
                <S.CardPlans selected={selectedPlanType === "prePago" ? true: planSeleted.value === "6" ? true : false}>
                  <S.CardPlansHeader>
                    <Auxiliar color={theme.colors.red.Tostado}>
                      Desconto progressivo
                    </Auxiliar>
                  </S.CardPlansHeader>

                  <S.CardPrice>
                    {cupomAplicaPrePago &&
                        <Auxiliar color={theme.colors.gray.Cinza_2}>
                          R$ {planValues.prePago}
                        </Auxiliar>
                      }

                    <H5 color={theme.colors.gray.Cinza_2}>
                      {cupomAplicaPrePago ? (
                        <>
                          R${" "}
                          {applyPercentageDiscount(
                            planValues.prePago,
                            cupomValue
                          )}
                        </>
                      ) : (
                        <>R$ {planValues.prePago}</>
                      )}
                    </H5>
                    <Auxiliar color={theme.colors.gray.Cinza_2}>
                      {cupom === "BEMVINDO" && selectedPlanType !== "prePago"
                        ? "por receita (primeiro mês)"
                        : "por receita"}
                    </Auxiliar>
                  </S.CardPrice>

                  <S.CardFooter>
                    <Minimo color={theme.colors.gray.Cinza_2}>
                      Total para{" "}
                      <b>
                        {effectiveCount} receita{effectiveCount > 1 ? "s" : ""}:
                      </b>
                    </Minimo>
                    <Minimo color={theme.colors.gray.Cinza_2}>
                      {cupomAplicaPrePago ? (
                        <>
                          R${" "}
                          {applyPercentageDiscount(
                            parseFloat(planValues.prePago.replace(",", ".")) *
                              effectiveCount,
                            cupomValue
                          )}
                        </>
                      ) : (
                        <b>
                          R${" "}
                          {formatCurrency(
                            parseFloat(planValues.prePago.replace(",", ".")) *
                              effectiveCount
                          )}
                        </b>
                      )}
                    </Minimo>
                  </S.CardFooter>

                  <label className="radio-wrapper">
                    <input
                      type="radio"
                      id="prePago"
                      name="card_price"
                      checked={true}
                      onChange={() => setSelectedPlanType("prePago")}
                    />
                    <span className="custom-radio" />
                  </label>
                </S.CardPlans>
              ) : (
                <>
                {!(plan.length && plan[0].plans_grid && !plan[0].plans_grid.some(grid => grid.renew_type_id === 4 || grid.renew_type_id === 2)) && (
                  <S.CardPlans
                    selected={selectedPlanType === "anual"}
                    onClick={() => {
                      setSelectedPlanType("anual");
                      if (plan.length && plan[0].plans_grid) {
                        const adjustedCount = !users || users < 1 ? 1 : users;
                        const anualPlan = plan[0].plans_grid.find(
                          grid => grid.renew_type_id === 4 && grid.qtd_users === adjustedCount
                        );
                      }
                    }}
                  >
                    <S.CardPlansHeader>
                      <H6 color={theme.colors.gray.Cinza_2}>Anual</H6>
                      {percentageApplied > 0 && !anualMaisCaroQueMensal && (
                        <Auxiliar color={theme.colors.red.Tostado}>
                          {percentageApplied}% de desconto
                        </Auxiliar>
                      )}
                    </S.CardPlansHeader>
                    <S.CardPrice>
                      {cupomAplicaAnual &&
                        <Auxiliar color={theme.colors.gray.Cinza_2}>
                          R$ {calculateMonthlyFromAnnual(planValues.anual)}
                        </Auxiliar>
                      }

                      <H5 color={theme.colors.gray.Cinza_2}>
                        {cupomAplicaAnual ? (
                          <>
                            R${" "}
                            {
                              applyPercentageDiscount(
                                calculateMonthlyFromAnnual(planValues.anual),
                                cupomValue
                            )}
                          </>
                        ) : (
                          <>R$ {roundCentsUnitsDownForDisplay(calculateMonthlyFromAnnual(planValues.anual))}</>
                        )}
                      </H5>
                      <Auxiliar color={theme.colors.gray.Cinza_2}>
                        {cupom === "BEMVINDO"
                          ? "por usuário (primeiro mês)"
                          : "mensais/usuário"}
                      </Auxiliar>
                    </S.CardPrice>

                    <S.CardFooter>
                      <Minimo color={theme.colors.gray.Cinza_2}>
                        Total para{" "}
                        <b>
                          {effectiveCount} usuário
                          {effectiveCount > 1 ? "s" : ""}:
                        </b>
                      </Minimo>
                      <Minimo color={theme.colors.gray.Cinza_2}>
                        {cupomAplicaAnual ? (
                          <b>
                            R$ {calculateAnnualWithDiscount()}/ano
                          </b>
                        ) : (
                          <b>
                            R${" "}
                            {formatCurrency(
                              parseFloat(planValues.anual.replace(",", ".")) * effectiveCount
                            )}
                            /ano
                          </b>
                        )}
                      </Minimo>
                    </S.CardFooter>

                    <label className="radio-wrapper">
                      <input
                        type="radio"
                        id="anual"
                        name="card_price"
                        checked={selectedPlanType === "anual"}
                        onChange={() => setSelectedPlanType("anual")}
                      />
                      <span className="custom-radio" />
                    </label>
                  </S.CardPlans>
                  )}

                  <S.CardPlans
                    selected={selectedPlanType === "mensal" ? true : false}
                    onClick={() => {
                      setSelectedPlanType("mensal");
                      if (plan.length && plan[0].plans_grid) {
                        const adjustedCount = !users || users < 1 ? 1 : users;
                        const mensalPlan = plan[0].plans_grid.find(
                          grid => grid.renew_type_id === 2 && grid.qtd_users === adjustedCount
                        );
                      }
                    }}
                  >
                    <S.CardPlansHeader>
                      <H6 color={theme.colors.gray.Cinza_2}>Mensal</H6>
                      
                      <Auxiliar color={theme.colors.gray.Cinza_5}>
                      {checkoutPlanId !== 9 && checkoutPlanId !== 10 ? "Cancele quando quiser" : ""}
                      </Auxiliar>
                    </S.CardPlansHeader>

                    <S.CardPrice>
                      {cupomAplicaMensal &&
                        <Auxiliar color={theme.colors.gray.Cinza_2}>
                          R$ {planValues.mensal}
                        </Auxiliar>
                      }

                      <H5 color={theme.colors.gray.Cinza_2}>
                        {cupomAplicaMensal ? (
                          <>
                            R${" "}
                            {roundCentsUnitsDownForDisplay(
                              applyPercentageDiscount(
                                planValues.mensal,
                                cupomValue
                              )
                            )}
                          </>
                        ) : (
                          <>R$ {roundCentsUnitsDownForDisplay(planValues.mensal)}</>
                        )}
                      </H5>
                      <Auxiliar color={theme.colors.gray.Cinza_2}>
                        {cupom === "BEMVINDO"
                          ? "por usuário (primeiro mês)"
                          : "mensais/usuário"}
                      </Auxiliar>
                    </S.CardPrice>

                    <S.CardFooter>
                      <Minimo color={theme.colors.gray.Cinza_2}>
                        Total para{" "}
                        <b>
                          {effectiveCount} usuário
                          {effectiveCount > 1 ? "s" : ""}:
                        </b>
                      </Minimo>
                      <Minimo color={theme.colors.gray.Cinza_2}>
                        <b>
                          {cupom ? (
                            <>
                              R$ {calculateMonthlyForUserWithCupom(planValues.mensal)}/mês
                            </>
                          ):(
                            <>
                              R$ {calculateMonthlyForUser(planValues.mensal)}/mês
                            </>
                          )}
                          
                        </b>
                        {cupomValue && cupom === "BEMVINDO" ? (<span>(a partir do 2º mês)</span>) : ""}
                      </Minimo>
                    </S.CardFooter>

                    <label className="radio-wrapper">
                      <input
                        type="radio"
                        id="mensal"
                        name="card_price"
                        checked={selectedPlanType === "mensal" ? true : false}
                        onChange={() => setSelectedPlanType("mensal")}
                      />
                      <span className="custom-radio" />
                    </label>
                  </S.CardPlans>
                </>
              )}
            </S.ContainerCardPlans>
          )}
        </S.ContainerInputs>
      </S.ContentSimulation>
    </S.ContainerContentSimulation>
  );
}

export default AcordionCardSimulation;
